import React from 'react';
import { ReportListTemplate } from 'themes/modules/report/pages';
import { ReportListViewStore } from 'modules/report/stores';
import { setCurrentView } from 'core/utils';

@setCurrentView(rootStore => new ReportListViewStore(rootStore), 'reportListViewStore')
class ReportList extends React.Component {
	constructor(props) {
		super(props);
	}

	render() {
		return <ReportListTemplate {...this.props} />;
	}
}

export default ReportList;
